import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
// import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import Layout from "../Layout/Layout.jsx";
import FullPageLoader from "../FullPageLoader/FullPageLoader.jsx";
import CookieBanner from "../CookieBanner/CookieBanner.jsx";
import TeacherHints from "../TeacherHints/TeacherHints.jsx";
import StudentHints from "../StudentHints/StudentHints.jsx";
import I18nRoutes from "../I18nRoutes.jsx";

import useAuthInit from "../../hooks/useAuthInit.js";
import useStudentAuthInit from "../../hooks/useStudentAuthInit.js";
import { getStudentProfile } from "../../redux/authStudent/operation.js";
import { getTeacherProfile } from "../../redux/authTeacher/operation.js";
import { fetchUnreadCount } from "../../redux/chat/operations.js";

import { selectIsRefreshingSession } from "../../redux/authTeacher/selector.js";

import { selectStudentIsRefreshingSession } from "../../redux/authStudent/selector.js";
import LanguageSync from "../LanguageSync.jsx";
import { useSocket } from "../../hooks/useSocket.js";
import DonationModal from "../DonationModal/DonationModal.jsx";

function App() {
  // const [showDonationModal, setShowDonationModal] = useState(false); //
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  useSocket();
  useAuthInit();
  useStudentAuthInit();
  const dispatch = useDispatch();
  // const location = useLocation();

  const isRefreshingSession = useSelector(selectIsRefreshingSession);
  const isStudentRefreshing = useSelector(selectStudentIsRefreshingSession);
  const studentToken = useSelector((state) => state.authStudent.studentToken);
  const teacherToken = useSelector((state) => state.authTeacher.teacherToken);
  const studentData = useSelector((state) => state.authStudent.studentData);
  const teacherData = useSelector((state) => state.authTeacher.teacherData);

  useEffect(() => {
    if (studentToken && !studentData) {
      dispatch(getStudentProfile());
    }
    if (teacherToken && !teacherData) {
      dispatch(getTeacherProfile());
    }
    if ((studentToken && studentData) || (teacherToken && teacherData)) {
      dispatch(fetchUnreadCount());
    }
  }, [studentToken, teacherToken, studentData, teacherData, dispatch]);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowDonationModal(true);
  //   }, 6000);

  //   return () => clearTimeout(timer); // очищаем при размонтировании
  // }, []);
  useEffect(() => {
    const cookieTimer = setTimeout(() => {
      setShowCookieBanner(true);
    }, 1500);
    return () => clearTimeout(cookieTimer);
  }, []);
  if (
    isRefreshingSession ||
    isStudentRefreshing ||
    (teacherToken && !teacherData) ||
    (studentToken && !studentData)
  ) {
    return <FullPageLoader />;
  }

  return (
    <>
      {/* {showDonationModal && <DonationModal />} */}

      {showCookieBanner && <CookieBanner />}
      {/* <Layout> */}
      <LanguageSync />
      <I18nRoutes />
      <TeacherHints />
      <StudentHints />
      {/* </Layout> */}
      <ToastContainer position="top-right" autoClose={1000} />
    </>
  );
}

export default App;
